import {Tailwind} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useViewer} from '../../../state/viewer/hooks';
import {InstrumentedLoader as Loader} from '../../utility/InstrumentedLoader';
import {useIsProjectReadOnly} from '../common/hooks';
import {useRegistryAccountSettings} from '../common/RegistryAccountSettings';
import {globalRegistryType} from '../common/utils';
import {RegistryDetails} from './RegistryDetails';
import {RegistryDetailsReadOnly} from './RegistryDetailsReadOnly';
import {RegistryMembersContextProvider} from './RegistryMembersContextProvider';
import {RegistryMembersTable} from './RegistryMembersTable/RegistryMembersTable';
import {RegistryProtectedAliases} from './RegistryProtectedAliases';
import {RegistrySettingsPageHeader} from './RegistrySettingsPageHeader';

type RegistrySettingsPageProps = {
  registry: globalRegistryType;
};

export const RegistrySettingsPage = ({registry}: RegistrySettingsPageProps) => {
  const {isProjectReadOnly: readOnly, loading: isProjectReadOnlyLoading} =
    useIsProjectReadOnly(registry.entityName, registry.registryProjectName);
  const accountSettings = useRegistryAccountSettings();
  const viewer = useViewer();

  if (isProjectReadOnlyLoading) {
    return (
      <Tailwind style={{height: '100%', width: '100%'}}>
        <div className="relative min-h-[500px] w-full">
          <Loader name="registry-settings-page" />
        </div>
      </Tailwind>
    );
  }

  return (
    <RegistryMembersContextProvider registry={registry} viewer={viewer}>
      <Tailwind style={{height: '100%', width: '100%', paddingBottom: '80px'}}>
        <RegistrySettingsPageHeader registry={registry} />
        {readOnly ? (
          <RegistryDetailsReadOnly registry={registry} />
        ) : (
          <RegistryDetails currentRegistry={registry} />
        )}
        <RegistryMembersTable
          registry={registry}
          accountSettings={accountSettings}
        />
        <RegistryProtectedAliases registry={registry} />
      </Tailwind>
    </RegistryMembersContextProvider>
  );
};
